import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DragDropContext } from "react-beautiful-dnd";
import { Col } from "react-bootstrap";
import { moveColumn, moveCard, getCrewInfo } from "../../../actions/crew-kanban";
import Columns from "../Column/Columns";
import Unassigned from "../Unassigned/Unassigned";
import { searchWord } from "../../../helpers/common";

const BoardBody = () => {
    const kanbanWrapper = useRef();
    const dispatch = useDispatch();
    const egListById = useSelector((state) => state.crewKanban.egListById);

    const onDragEnd = result => {
        const { source, destination, type, draggableId } = result;
        if (!destination) return;
        if (source.droppableId === "assigned") {
            const getAssignedCrewId = egListById[draggableId].crewId;
            let isAssign = true;
            dispatch(getCrewInfo([getAssignedCrewId], { isAssign, egId: draggableId }));
        }

        if (type === "column") {
            dispatch(moveColumn({
                oldColumnIndex: source.index,
                newColumnIndex: destination.index
            }));
            return;
        }

        dispatch(moveCard({
            oldCardIndex: source.index,
            newCardIndex: destination.index,
            sourceCrewId: source.droppableId,
            destCrewId: destination.droppableId
        }));
    };

    const onBeforeCapture = before => {
        if (!searchWord(before.draggableId, "column")) return;
        kanbanWrapper.current.scrollTo(0, 0);
    };

    const onDragStart = ({ type }) => {
        if (type !== "column") kanbanWrapper.current.scrollTo(0, 0);
    }

    return (<DragDropContext onBeforeCapture={onBeforeCapture} onDragStart={onDragStart} onDragEnd={onDragEnd}>
        <div className="kanban-body kanban-columns row" ref={kanbanWrapper} >
            <Col lg={10} className="m-0">
                <Columns />
            </Col>
            <Col lg={2} className="m-0 kanban-column-wrap kanban-column-fixed crewDrag_container">
                <Unassigned />
            </Col>
        </div>
    </DragDropContext>);
};

export default BoardBody;